import { cloneDeep } from 'lodash';
import { AnyAction } from 'redux';
import { BlogsInitialState } from '../models/blogsModel';
import actionTypes from '../types/blogsTypes';

const defaultInitialState: BlogsInitialState = {
  blogs: [],
  selectedModule: null,
  currentLevel: 0,
  selectedSubModule: null,
  articleList: [],
};

const initialState = cloneDeep(defaultInitialState);

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.SET_CURRENT_LEVEL:
      return {
        ...state,
        currentLevel: action.payload,
      };
    case actionTypes.SELECT_SUB_MODULE:
      return {
        ...state,
        selectedSubModule: action.payload,
      };
    case actionTypes.SET_CURRENT_MODULE:
      return {
        ...state,
        selectedModule: action.payload,
      };
    case actionTypes.SET_ARTICLE_LIST:
      return {
        ...state,
        articleList: action.payload,
      };
    case actionTypes.SET_BLOGS_FROM_SERVER:
      return {
        ...state,
        blogs: action.payload,
      };
    case actionTypes.RESET_DEFAULT:
      const updatedState = cloneDeep(initialState);
      return {
        ...updatedState,
        blogs: state.blogs,
      };
    default: return state;
  }
};

export { reducer as blogsReducer };
